import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container } from '@material-ui/core';
import { BaseUrl, endpoints } from '../utils/factory';
import AddNewExtraChargesToolbar from 'components/AddNewExtraChargesPage/AddNewExtraChargesToolbar';
import AddNewExtraChargesResult from 'components/AddNewExtraChargesPage/AddNewExtraChargesResult';

const axios = require('axios');

const AddNewExtraChargesPage = () => {
    const [invoicelist, setInvoicelList] = useState([]);
    const [settlementInvoicelist, setSettlementInvoicelist] = useState([]);
    const [changeflag, setChangeFlag] = useState(false);
    const [bookedfilter, setBookedfilter] = useState(5);
    const [statusfilter, setStatusfilter] = useState(0);
    const [fromdate, setFromdate] = useState();
    const [todate, setTodate] = useState();
    const [loaderflag, setLoderFlag] = useState(false);
    const [exportflag, setExportFlag] = useState(true);
    const [exportflagver, setExportFlagVer2] = useState(true);
    const [exportflagverCSV, setExportFlagVerCsv] = useState(true);
    const [invoicelistexport, setInvoicelListExport] = useState([]);
    const [invoicelistexportver, setInvoicelListExportVer] = useState([]);
    const [invoicelistexportcsv, setInvoicelListExportCsv] = useState([]);
    const [resetData, setResetData] = useState(false);
    const [searchtext, setSearchText] = useState('');
    const [toggleButton, setToggleButton] = useState(false);

    //comment message
    const [erorMessage, setErrorMessage] = useState('');
    const [visible, setVisible] = useState(false);

    const clientid = localStorage.getItem('trans-userId');
    const cmp_id = localStorage.getItem('trans-cmp_id');
    const clientName = localStorage.getItem('trans-userName');


    const handleResetFilter = () => {
        // setBookedfilter(5);
        // setStatusfilter(0);
    };

    const handleCloseMessage = () => {
        setVisible(false);
        setErrorMessage('');
    }

    const handleSearchText = (inv) => {
        setSearchText(inv);
    };

    const handleDate = async (amount, comment) => {

        let remarks = comment.trim();
        if (statusfilter == '') {
            setVisible(true);
            setLoderFlag(false);
            setErrorMessage('Please select settlement No');
        } else if (bookedfilter === '') {
            setVisible(true);
            setLoderFlag(false);
            setErrorMessage('Please select delivery type');
        } else if (amount == '') {
            setVisible(true);
            setLoderFlag(false);
            setErrorMessage('Please enter amount');
        } else if (remarks == '') {
            setVisible(true);
            setLoderFlag(false);
            setErrorMessage('Please add comment');
        } else {
            setToggleButton(true);
            setExportFlagVer2(true);
            setExportFlagVerCsv(true);
            setChangeFlag(true);
            setLoderFlag(true);
            setResetData(false);
            setInvoicelList([]);
            setVisible(false)

            try {
                axios
                    .post(`${BaseUrl}${endpoints.settleExtraCharges}`, {
                        Userid: clientid,
                        Settleid: statusfilter,
                        qtype: '1',
                        Description: bookedfilter,
                        Amount: amount,
                        Commentdesc: remarks,
                        createdby: clientid,
                        cmp_id:cmp_id,
                    })
                    .then((response) => {
                        if (response.data.length > 0) {
                            const userdata = response.data.d;
                            setInvoicelList(userdata);
                            setLoderFlag(false);
                            setStatusfilter('');
                            setBookedfilter('');
                            setResetData(true);
                            setVisible(true);
                            setToggleButton(false);
                            setErrorMessage('Settlement has been successfully added');
                        } else {
                            setInvoicelList([]);
                            setLoderFlag(false);
                        }
                    })
                    .catch((error) => {
                        console.log('API error', error);
                    });
            } catch (error) {
                console.log(error);
            }
        }
    };


    const handleChangeDeliveryType = (event) => {
        setBookedfilter(event.target.value);
    };

    const handleChangeSettlementSno = (event) => {
        setStatusfilter(event.target.value);
    };

    const handleChaneSettlement = () => {
        setExportFlagVer2(true);
        setExportFlagVerCsv(true);
        setChangeFlag(true);
        setLoderFlag(true);
        setSettlementInvoicelist([]);
        try {
            axios
                .post(`${BaseUrl}InvoiceSettlement`, {
                    supplier: clientid,
                    qtype: '6',
                    status: '5',
                    Fromdate: '',
                    Todate: '',
                    settlemnet: '',
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
                    }
                })
                .then((response) => {
                    if (response.data.d.length > 0) {
                        const userdata = eval(response.data.d);
                        setSettlementInvoicelist(userdata);
                        setLoderFlag(false);
                    } else {
                        setSettlementInvoicelist([]);
                        setLoderFlag(false);
                    }
                })
                .catch((error) => {
                    console.log('API error', error);
                });
        } catch (error) {
            console.log(error);
        }

    };

    const handleAddedNewSettlements = () => {
        setExportFlagVer2(true);
        setExportFlagVerCsv(true);
        setChangeFlag(true);
        setLoderFlag(true);
        setInvoicelList([]);
        try {
            axios
                .post(`${BaseUrl}sSetViewExtraCharge`, {
                    Userid: clientid,
                    Settleid: '',
                    qtype: '7',
                    Description: '',
                    Amount: '',
                    Commentdesc: '',
                    createdby: '',
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
                    }
                })
                .then((response) => {
                    if (response.data.d.length > 0) {
                        const userdata = eval(response.data.d);

                        setInvoicelList(userdata);
                        setLoderFlag(false);
                        setStatusfilter('');
                        setBookedfilter('');
                    } else {
                        setInvoicelList([]);
                        setLoderFlag(false);
                    }
                })
                .catch((error) => {
                    console.log('API error', error);
                });
        } catch (error) {
            console.log(error);
        }

    };

    const handleDeleteSettlement = (item, settlementId) => {
        setLoderFlag(true);
        setInvoicelList([]);
        try {
            axios
                .post(`${BaseUrl}sSetDeleteExtraCharge`, {
                    Userid: clientid,
                    qtype: '8',
                    Sno: item,
                    Settleid: settlementId,
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
                    }
                })
                .then((response) => {
                    if (response.data.d.length > 0) {
                        const userdata = eval(response.data.d);
                        setInvoicelList(userdata);
                        setLoderFlag(false);
                    } else {
                        setInvoicelList([]);
                        setLoderFlag(false);
                    }
                })
                .catch((error) => {
                    console.log('API error', error);
                });
        } catch (error) {
            console.log(error);
        }
    }

    const handlesearch = async (e, type) => {
        if (e.code === 'Enter' || type === '2') {
            if (type === '1' && e.target.value === '') return;
            setChangeFlag(true);
            setExportFlagVer2(true);
            setExportFlagVerCsv(true);
            setLoderFlag(true);
            handleResetFilter();
            try {
                setInvoicelList([]);

                axios
                    .post(`${BaseUrl}sSetViewExtraChargeSelection`, {
                        Userid: clientid,
                        Settleid: type === '1' ? e.target.value : e,
                        qtype: '9',
                        description: '',
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
                        }
                    })
                    .then((response) => {
                        if (response.data.d.length > 0) {
                            const userdata = eval(response.data.d);
                            setInvoicelList(userdata);
                        } else {
                            setInvoicelList([]);
                        }
                        setLoderFlag(false);
                    })
                    .catch((error) => {
                        console.log('API error', error);
                        setLoderFlag(false);
                    });
            } catch (error) {
                console.log(error);
            }
        }
    };

    useEffect(() => {
        handleChaneSettlement();
        handleAddedNewSettlements();
    }, []);

    return (
        <>
            <Helmet>
                <title>Invoice List</title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth={false}>
                    <AddNewExtraChargesToolbar
                        resetData={resetData}
                        handleSearchText={handleSearchText}
                        addNewExtraCharge={handleDate}
                        toggleButton={toggleButton}
                        customers={settlementInvoicelist && settlementInvoicelist}
                        handleChangeDeliveryType={handleChangeDeliveryType}
                        handleChangeSettlementSno={handleChangeSettlementSno}
                        selectvalue={bookedfilter}
                        selectvalues={statusfilter}
                        fromdate={fromdate}
                        todate={todate}
                        handleresetfilter={handleResetFilter}
                        clickToSearch={handlesearch}
                    />
                    <Box sx={{ pt: 3 }}>
                        <AddNewExtraChargesResult
                            customers={invoicelist && invoicelist}
                            erorMessage={erorMessage}
                            visible={visible && visible}
                            handleCloseMessage={handleCloseMessage}
                            flagstatus={changeflag}
                            fromdate={fromdate}
                            todate={todate}
                            datesearch={handleDate}
                            loaderflag={loaderflag}
                            exportlist={invoicelistexport}
                            exportflag={exportflag}
                            exportlisttwo={invoicelistexportver}
                            exportflagver={exportflagver}
                            invoicelistexportcsv={invoicelistexportcsv}
                            handleDeleteSettlement={handleDeleteSettlement}
                        />
                    </Box>
                </Container>
            </Box>
        </>
    );
};

export default AddNewExtraChargesPage;
